import React from 'react';
import { TaskPriority } from '../../types/task';
import { cn } from '../../utils/cn';

interface PrioritySelectProps {
  value: TaskPriority | undefined;
  onChange: (priority: TaskPriority | undefined) => void;
  className?: string;
}

export const PrioritySelect: React.FC<PrioritySelectProps> = ({
  value,
  onChange,
  className,
}) => {

  const getPriorityColor = (priority: TaskPriority | 'none') => {
    switch (priority) {
      case 'low':
        return 'hover:bg-emerald-500/10 data-[selected=true]:bg-emerald-500/10 data-[selected=true]:text-emerald-500 data-[selected=true]:border-emerald-500 data-[selected=true]:shadow-emerald-500/25';
      case 'medium':
        return 'hover:bg-blue-500/10 data-[selected=true]:bg-blue-500/10 data-[selected=true]:text-blue-500 data-[selected=true]:border-blue-500 data-[selected=true]:shadow-blue-500/25';
      case 'high':
        return 'hover:bg-orange-500/10 data-[selected=true]:bg-orange-500/10 data-[selected=true]:text-orange-500 data-[selected=true]:border-orange-500 data-[selected=true]:shadow-orange-500/25';
      case 'urgent':
        return 'hover:bg-red-500/10 data-[selected=true]:bg-red-500/10 data-[selected=true]:text-red-500 data-[selected=true]:border-red-500 data-[selected=true]:shadow-red-500/25';
      case 'none':
        return 'hover:bg-slate-500/10 data-[selected=true]:bg-slate-500/10 data-[selected=true]:text-slate-500 data-[selected=true]:border-slate-500 data-[selected=true]:shadow-slate-500/25';
    }
  };

  return (
    <div className={cn('space-y-2', className)}>
      <div className="grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => onChange(undefined)}
          data-selected={value === undefined}
          className={cn(
            'px-4 py-2 rounded-lg border-2 transition-all text-sm font-medium',
            'hover:border-primary/30',
            'data-[selected=true]:border-primary data-[selected=true]:shadow-lg',
            getPriorityColor('none')
          )}
        >
          No Priority
        </button>
        {(['low', 'medium', 'high', 'urgent'] as const).map((priority) => {
          const labels = {
            low: 'Low',
            medium: 'Medium', 
            high: 'High',
            urgent: 'Urgent'
          };
          return (
            <button
              key={priority}
              type="button"
              onClick={() => onChange(priority)}
              data-selected={value === priority}
              className={cn(
                'px-4 py-2 rounded-lg border-2 transition-all text-sm font-medium',
                'hover:border-primary/30',
                'data-[selected=true]:border-primary data-[selected=true]:shadow-lg',
                getPriorityColor(priority)
              )}
            >
              {labels[priority]}
            </button>
          );
        })}
      </div>
    </div>
  );
};